<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('category')">
            <a :href="urlGenerator('/hotel/achievement')" class="btn btn-success mr-2">
                <app-icon class="size-20 mr-2" name="arrow-left"/>
                {{ $t('back') }}
            </a>
            <app-default-button
                :title="$fieldTitle('add', 'category', true)"
                v-if="$can('create_hotel_achievement')"
                @click="openModal()"
            />
        </app-page-top-section>

        <app-table
            id="hotel-achievement-category-table"
            :options="options"
            @action="triggerActions"
        />

        <app-hotel-achievement-category-create
            v-if="isModalActive"
            v-model="isModalActive"
            :selected-url="selectedUrl"
            @close="isModalActive = false"
        />

        <app-confirmation-modal
            v-if="confirmationModalActive"
            icon="trash-2"
            modal-id="app-confirmation-modal"
            @confirmed="confirmed('hotel-achievement-category-table')"
            @cancelled="cancelled"
        />
    </div>
</template>

<script>
import HelperMixin from "../../../../../common/Mixin/Global/HelperMixin";
import HotelAchievementCategoryMixins from "../../../Mixins/HotelAchievementCategoryMixins";
import {TENANT_BASE_URL} from "../../../../../common/Config/UrlHelper";

export default {
    name  : "AppHotelAchievementCategory",
    mixins: [HelperMixin, HotelAchievementCategoryMixins, TENANT_BASE_URL],
    data() {
        return {
            isModalActive: false,
            selectedUrl  : '',
        }
    },
    methods: {
        triggerActions(row, action, active) {
            if (action.title === this.$t('edit')) {
                this.selectedUrl   = `${TENANT_BASE_URL}app/hotel/achievement-category/${row.id}`;
                this.isModalActive = true;
            } else {
                this.getAction(row, action, active)
            }
        },
        openModal() {
            this.isModalActive = true;
            this.selectedUrl   = ''
        },
    }
}
</script>